export default __webpack_public_path__ + "static/thumbnail-1acabe45cc9334a04f0ea29f271c6052.png";